import styled from 'styled-components'

export const Container = styled.div`
  background-color: #FFFFFF;
  height: 42px;
  margin: 0px 10px 12px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: grid;
  grid-template-columns: 1fr 20px;
  gap: 10px;
  justify-content: space-around;
  align-items: center;
  padding: 0px 20px;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 15px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: 500;
`
